import { render, staticRenderFns } from "./AffidavitOfPersonalServiceOfProtection.vue?vue&type=template&id=36bc2092"
import script from "./AffidavitOfPersonalServiceOfProtection.vue?vue&type=script&lang=ts"
export * from "./AffidavitOfPersonalServiceOfProtection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports